<!--<div class="d-flex flex-sm-row mx-sm-0 mx-5 px-sm-0 px-5 flex-column gap-3 justify-content-between">-->
<!--  <div class="">-->
<!--    <ncp-button (click)="goToPS()">-->
<!--      <div class="home-tile btn-block button-container home-tile_current button-container_current">-->
<!--        <span class="label-text">{{ translations.patient_summary }}</span>-->
<!--        <div class="image-container">-->
<!--          <img-->
<!--            [ngSrc]="assets.img.patient.ps.src"-->
<!--            width="512"-->
<!--            height="512"-->
<!--            class="btn-img"-->
<!--            sizes="25vw"-->
<!--            alt="Go to PS"-->
<!--          />-->
<!--        </div>-->
<!--      </div>-->
<!--    </ncp-button>-->
<!--  </div>-->

<!--  <div class="">-->
<!--    <ncp-button (click)="goToEP()">-->
<!--      <div class="home-tile btn-block button-container home-tile_current button-container_current">-->
<!--        <span class="label-text">{{ translations.eprescriptions }}</span>-->
<!--        <div class="image-container">-->
<!--          <img-->
<!--            [ngSrc]="assets.img.patient.ep.src"-->
<!--            width="512"-->
<!--            height="512"-->
<!--            class="btn-img"-->
<!--            sizes="25vw"-->
<!--            alt="Go to EP"-->
<!--          />-->
<!--        </div>-->
<!--      </div>-->
<!--    </ncp-button>-->
<!--  </div>-->

<!--  <div class="">-->
<!--    <ncp-button (click)="goToORCD()">-->
<!--      <div class="home-tile btn-block button-container home-tile_current button-container_current">-->
<!--        <span class="label-text">{{ translations.orcd }}</span>-->
<!--        <div class="image-container">-->
<!--          <img-->
<!--            [ngSrc]="assets.img.patient.orcd.src"-->
<!--            width="512"-->
<!--            height="512"-->
<!--            class="btn-img"-->
<!--            sizes="25vw"-->
<!--            alt="Go to ORCD"-->
<!--          />-->
<!--        </div>-->
<!--      </div>-->
<!--    </ncp-button>-->
<!--  </div>-->
<!--</div>-->


<div
  class="d-flex flex-lg-row flex-column gap-3 justify-content-evenly align-items-center"
>
  <div
    class="d-flex flex-lg-row flex-column gap-3 justify-content-evenly"
  >


      <div class="card" style="width: 18rem;">
        <img [src]="psSrc" class="card-img-top card-bg" alt="Patient Summary">
        <div class="card-body d-flex flex-column">
          <h5 class="card-title">{{ translations.ps }}</h5>
          <p class="card-text flex-grow-1">{{ translations.ps_text }}</p>
          <ncp-button (click)="goToPS()">
            {{ translations.enter }}
          </ncp-button>
        </div>
      </div>


    <div class="card" style="width: 18rem;">
      <img [src]="epSrc" class="card-img-top card-bg" alt="ePrescriptions">
      <div class="card-body d-flex flex-column">
        <h5 class="card-title">{{ translations.ep }}</h5>
        <p class="card-text flex-grow-1">{{ translations.ep_text }}</p>
        <ncp-button (click)="goToEP()">
          {{ translations.enter }}
        </ncp-button>
      </div>
    </div>


    <div class="card" style="width: 18rem;">
      <img [src]="orcdSrc" class="card-img-top card-bg" alt="OrCD">
      <div class="card-body d-flex flex-column">
        <h5 class="card-title">{{ translations.orcd }}</h5>
        <p class="card-text flex-grow-1">{{ translations.orcd_text }}</p>
        <ncp-button (click)="goToORCD()">
          {{ translations.enter }}
        </ncp-button>
      </div>
    </div>


    <div class="card" style="width: 18rem;">
      <img [src]="euVacSrc" class="card-img-top card-bg" alt="euVac">
      <div class="card-body d-flex flex-column">
        <h5 class="card-title">{{ translations.vac }}</h5>
        <p class="card-text flex-grow-1">{{ translations.vac_text }}</p>
        <ncp-button (click)="goToEuVac()">
          {{ translations.enter }}
        </ncp-button>
      </div>
    </div>

  </div>

</div>
